import { FC, useEffect, useMemo } from 'react';

import { useSKU } from 'hooks';
import { useFormikContext } from 'formik';

import FormikInput from 'components/primitives/FormikInput';

export const TotalItemsInput: FC<{ i: number; washHubId: string }> = ({
  i,
  washHubId,
}) => {
  const { data } = useSKU('package', washHubId);
  const { values, setFieldValue } = useFormikContext<any>();

  const skuSize = useMemo(() => {
    const item = values?.details?.[i];
    const _sku = data?.find((s) => {
      if (typeof item?.sku === 'string') {
        return s._id === item?.sku;
      }

      return s._id === item?.sku?._id;
    });

    const totalQuantity = ((_sku as any)?.items as any[])
      ?.map((i) => i?.quantity)
      ?.reduce?.((acc, current) => acc + current, 0);

    return Number(item.casesCount || '0') * Number(totalQuantity || '0');
  }, [JSON.stringify(values?.details?.[i])]);

  useEffect(() => {
    setFieldValue(`details[${i}].totalItems`, skuSize);
  }, [skuSize]);

  return (
    <FormikInput
      type="number"
      id={`item-${i}`}
      label="Total items"
      labelProps={{ fontSize: '12px', color: '#afafaf' }}
      containerProps={{ flex: 1 }}
      name={`details[${i}].totalItems`}
      isReadOnly
    />
  );
};
